import type { SVGProps } from 'react';

export const Work = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.3 20.5c-.5 0-.925-.175-1.275-.525A1.736 1.736 0 0 1 2.5 18.7V8.3c0-.5.175-.925.525-1.275.35-.35.775-.525 1.275-.525h4.2V4.8c0-.5.175-.925.525-1.275C9.375 3.175 9.8 3 10.3 3h3.4c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v1.7h4.2c.5 0 .925.175 1.275.525.35.35.525.775.525 1.275v10.4c0 .5-.175.925-.525 1.275-.35.35-.775.525-1.275.525H4.3Zm0-1.5h15.4c.067 0 .133-.033.2-.1s.1-.133.1-.2V8.3c0-.067-.033-.133-.1-.2s-.133-.1-.2-.1H4.3c-.067 0-.133.033-.2.1s-.1.133-.1.2v10.4c0 .067.033.133.1.2s.133.1.2.1ZM10 6.5h4V4.8c0-.067-.033-.133-.1-.2s-.133-.1-.2-.1h-3.4c-.067 0-.133.033-.2.1s-.1.133-.1.2v1.7ZM4 19V8v11Z" />
    </svg>
  );
};
